import React from 'react';

import {getRapidNaming, getTestLanguage} from '../../constants/tests.js';

import StopWatch from '../../components/StopWatch';

import AdminTestPanel from '../../components/AdminTestPanel';
import AdminReadyButton from '../../components/AdminReadyButton';

import strings from '../../strings';

import {normingGrade567YouthAdultImages} from './assets';
import {TYPES} from '../../constants/index';




class Admin extends AdminTestPanel {

	 constructor(props) {
    super(props);
    this._timerStartedFor = null;
  }

  componentWillReceiveProps(newProps) {
    super.componentWillReceiveProps(newProps);

    const enteredTest =
      this.props.currentStage !== newProps.currentStage && newProps.currentStage === 1;

    const stepChanged =
      this.props.currentStep !== newProps.currentStep && newProps.currentStage === 1;

    if ((enteredTest || stepChanged) && this._timerStartedFor !== newProps.currentStep) {
      this._timerStartedFor = newProps.currentStep;
      this.props.startTimer();
    }
  }

	getTestName = () => {
		return strings.rn_testname;
	};


	updateTimeUsed = (timeUsed) => {
		this.setState({timeUsed: timeUsed});
	};

	getImage = (color, item) => {
		
		if (
			this.props.testKeyType === TYPES.ADULT_FOLLOWUP ||
			this.props.testKeyType === TYPES.YOUTH_FOLLOWUP
		) {
			if (normingGrade567YouthAdultImages[color + item])
				return normingGrade567YouthAdultImages[color + item];
		} 
		console.error('Item ' + color + item + ' not found');
		return null;
	};

	renderIntro = () => {
		const {currentStep} = this.props;

		return (
			<div>
				
				{currentStep === 0 && (
							<>
							<p>{strings.rn_admin1}</p>
								<p>{strings.rn_admin11}</p>
								<p>{strings.rn_admin12}</p>

								<div className={`adminItemButtons`}>
									<button
										onClick={() => {
											this.props.nextStep();
										}}
									>
										{strings.startPracticeTasks}
									</button>
								</div>
							</>
						)}
				{currentStep === 1 && (
							<>
							<p>{strings.rn_admin1}</p>
								{/* <p className={`adminItemExpectedAnswer`}>
									{strings.rn_admin10}
								
								</p> */}
								<p className={`adminItemExpectedAnswer`}>
									{strings.rn_admin6}
								</p>
								<p className={`adminItemExpectedAnswer`}>
									{strings.formatString(
										strings.expectedAnswer,
										<b style={{color:'orange'}}>
											{
												strings.rn_objectsWithColors
											}
										</b>
									)}
								</p>
								<p className={`adminItemExpectedAnswer`}>
									{strings.rn_admin10}
								
								</p>
								<div className={`adminItemButtons`}>
									<button onClick={this.props.nextStep}>
										{strings.rn_correctItems}
									</button>{' '}
								</div>
							</>
						)}
				{currentStep === 2 && (
							<>
								<p>{strings.rn_admin13}</p>
								<p>{strings.rn_admin14}</p>
								<p>{strings.hotkeyCorrect}</p>
								<p>{strings.hotkeyWrong}</p>
								<p>{strings.hotUnanswered}</p>
								<p>{strings.whenReadyClickStart}</p>
								<AdminReadyButton
									remoteIsReady={this.props.candidateReady}
									onClick={this.props.nextStage}
								/>
							</>
						)}
			</div>
		);
	};
	returnProperAdjective = (color, item) => {
	
		
		let returnAnswer = `${color} ${item}`
		const itemWithColor = `${color}_${item}`;
		switch (itemWithColor) {
			case 'grön_bord':
				returnAnswer = 'grönt bord';
				break;
			case 'grön_äpple':
				returnAnswer = 'grönt äpple';
				break;
			case 'grå_bord':
				returnAnswer = 'grått bord';
				break;
			case 'grå_äpple':
				returnAnswer = 'grått äpple';
				break;
			default:
				returnAnswer = `${color} ${item}`;
		}
	return returnAnswer;
	
	}

	returnCorrectAnswer(color,item){

		const adjective = {
			blå:'blått',
			röd:'rött',
			grön:'grönt',
			grå:'grått',
		}

		if(adjective.hasOwnProperty(color) && ['äpple','bord'].includes(item)){
		
			return `${adjective[color]} ${item}`;
		}
	
		return `${color}  ${item}`;
	}

	renderTest = () => {
		const {currentStep} = this.state;
		const steps = getRapidNaming(this.props.ageGroup).getSteps();
		const testLang = getTestLanguage();

		return (
			<div>
				<p>
					<StopWatch autoStart integer onTick={this.updateTimeUsed} />
					<br />
					{strings.rn_admin8}
					<br />
					{strings.rn_admin9}
					<br />
					
					<p>{strings.hotkeyCorrect}</p> 
					<p>{strings.hotkeyWrong}</p>
					<p>{strings.hotUnanswered}</p>
				</p>
				<p className={`adminItemExpectedAnswer`}>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						steps.length
					)}
				</p>
				<p className={`adminItemExpectedAnswer`}>
					{strings.formatString(
						strings.expectedAnswer,
						<b>
							{
							steps[currentStep].item === 'apple' && [
								steps[currentStep].language,
							]
								? [steps[currentStep].language]
								: strings[steps[currentStep].color]}{' '}
							{strings[steps[currentStep].item]}
						</b>
					)}
				</p>

				<p className={`adminItem`}>
					<img
						src={this.getImage(
							steps[currentStep].color,
							steps[currentStep].item
						)}
					/>
				</p>
				<button
					onClick={(e) => {
						e.stopPropagation();

						this.answerCorrect();
					}}
				>
					{strings.hotkeyButtonCorrect}
				</button>
				<button
					onClick={(e) => {
						e.stopPropagation();

						this.answerWrong();
					}}
				>
					{strings.hotkeyButtonWrong}
				</button>
				<button
					onClick={(e) => {
						e.stopPropagation();
						this.answerUnanswered();
					}}
				>
					{strings.hotkeyButtonUnanswered}
				</button>
			</div>
		);
	};

	renderWaiting = () => {
		return (
			<div>
				<p>
					{strings.formatString(
						strings.testDone,
						strings.rn_testname
					)}
				</p>
				<p>
					{strings.formatString(
						strings.rn_timeUsed,
						this.state.timeUsed
					)}
				</p>
				<button onClick={() => this.props.nextStage()}>
					{strings.nextTest}
				</button>
			</div>
		);
	};
	answerCB = () => {
	};
}

export default Admin;
